import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { ApplyButton } from '_components';
import styles from './Common.module.css';
import { GoalTemplateDialog } from './GoalTemplateDialog';

class GoalTemplate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            template: -1,

        };
    }

    handleTemplateChange(event) {
        this.setState({
            template: event.target.value,
        });
    }

    applyTemplate() {
        this.props.toggleGoalTemplateDetails(this.props.noteId);
        this.setState({
            template: -1,
        });
    }

    render() {
        if (this.props.noteType === 2) {
            return (
                <span />
            );
        }
        else {
            return (
                <span className={styles.template_row}>
                    {this.props.templateVisible &&
                        <GoalTemplateDialog selected={this.state.template} />
                    }
                    <span className={styles.template_label}>Template:</span>
                    <select className={styles.template_dropdown} value={this.state.template} onChange={event => this.handleTemplateChange(event)}>
                        <option key={-1} value={-1} disabled>Select a template...</option>

                        {Object.keys(this.props.templates)
                            .map(id => {
                                const template = this.props.templates[id];
                                return (
                                    <option key={template.ID} value={template.GTNO}>{template.GTNAME}</option>
                                );
                            })
                        }
                    </select>

                    <span className={styles.template_button_wrapper}>
                        <ApplyButton title='Apply Template' size='extra-small' onClick={() => this.applyTemplate()} />
                    </span>

                </span>
            )
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleGoalTemplateDetails: bindActionCreators(noteActions.toggleGoalTemplateDetails, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let templates = Object.keys(state.entities.notes.PTGOALTEMPLATE)
        .filter(x => {
            return ((state.entities.notes.PTGOALTEMPLATE[x].NoteId === noteId));
        })
        .sort((a, b) => state.entities.notes.PTGOALTEMPLATE[a].GTORDER - state.entities.notes.PTGOALTEMPLATE[b].GTORDER)
        .map(key => state.entities.notes.PTGOALTEMPLATE[key]);

    let templateVisible = state.ui.notes[noteId].goalTemplateVisible;


    return {
        noteId,
        noteType,
        pk,
        templates,
        templateVisible
    };
}

const connectedGoalTemplate = connect(mapStateToProps, mapDispatchToProps)(GoalTemplate);
export { connectedGoalTemplate as GoalTemplate };
